export default {
	mounted() {
        const csoEnabled = this.$route.query && this.$route.query.cso === 'true' ? 'true' : 'false';
		localStorage.csoEnabled = csoEnabled;
        this.csoEnabled = csoEnabled;

        const recaptchaDisabled = this.$route.query && this.$route.query.cso === 'true' ? 'true' : 'false';
        localStorage.recaptchaDisabled = recaptchaDisabled;
        this.recaptchaDisabled = recaptchaDisabled;
	}
}